import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Quality_Control_Plan_Table from "./quality_control_plan_table/Quality_Control_Plan_Table";
import Quality_Control_Plan_Filter from "./quality_control_plan_filter/Quality_Control_Plan_Filter";

const Quality_Control_Plan = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Quality Control Plan Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Quality_Control_Plan_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Quality_Control_Plan_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Quality Control Plan Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Quality_Control_Plan;
